import { flip } from 'lodash'

// Route hook builders
// We use "flip" so that we can use the same hook for onEnter and onChange.

function requireAuth(authFunction, options = {}) {
  return flip((callback, replace, nextState) => {
    if (!authFunction()) {
      replace({
        pathname: options.redirectUrl || '/sign-in',
        state: { redirectUrl: constructUrl(nextState.location) },
      })
    }
  })
}

function excludeAuth(authFunction, options = {}) {
  return flip((callback, replace) => {
    if (authFunction()) replace(options.redirectUrl || '/')
    callback()
  })
}

// ----- PRIVATE -----

function constructUrl(location) {
  const { pathname, search, hash } = location
  return pathname + search + hash
}

export default { requireAuth, excludeAuth }
